import {
  PolicyContainer,
  PolicyTitle,
  PolicyText,
  PolicyList,
  PolicySectionTitle,
  PolicyHyphenList,
} from "styles/PolicyCommon";
import { useEffect } from "react";

const HealthId = () => {
  useEffect(() => {
    document.documentElement.lang = "id";
    document.title = "pregnancy&baby";
    return () => {
      document.documentElement.lang = "en";
      document.title = "pregnancy&baby";
    };
  }, []);

  return (
    <PolicyContainer>
      <h1 className="hide">pregnancy&amp;baby</h1>
      <PolicyTitle>
        Persetujuan atas Pengumpulan dan Penggunaan Informasi Kesehatan
      </PolicyTitle>

      <PolicyText>
        Saat membuat akun, Anda dapat memilih apakah akan memberikan persetujuan
        atas pengumpulan dan penggunaan informasi kesehatan. Persetujuan ini
        bersifat opsional dan tidak diwajibkan untuk membuat akun
        pregnancy&baby. Namun, jika Anda tidak memberikan persetujuan, Anda
        mungkin tidak dapat menggunakan fitur yang memerlukan pemrosesan
        informasi kesehatan.
      </PolicyText>

      <PolicySectionTitle>
        1. Tujuan Pengumpulan dan Penggunaan
      </PolicySectionTitle>
      <PolicyHyphenList>
        <li>
          Menyediakan fitur pencatatan dan pengelolaan terkait persiapan
          kehamilan, perawatan kesuburan, kehamilan, dan perawatan anak
        </li>
        <li>
          Menyediakan fitur yang dipersonalisasi sesuai pilihan Anda, termasuk
          prediksi menstruasi dan ovulasi, penghitungan usia kehamilan, analisis
          hasil tes, analisis pertumbuhan janin, serta analisis pertumbuhan dan
          perkembangan anak
        </li>
        <li>
          Memberikan pengingat dan informasi terkait kesehatan, kehamilan, dan
          perawatan anak berdasarkan pengaturan Anda
        </li>
      </PolicyHyphenList>

      <PolicySectionTitle>
        2. Informasi Kesehatan yang Dikumpulkan
      </PolicySectionTitle>
      <PolicyList>
        <li>
          <strong>[Persiapan Kehamilan]</strong>
          <br />
          Periode dan siklus menstruasi, tanggal menstruasi terakhir, tanggal
          mulai dan berakhirnya menstruasi, tanggal ovulasi, tanggal dan waktu,
          gambar dan hasil tes ovulasi, tanggal dan waktu, gambar dan hasil tes
          kehamilan, suhu basal tubuh, gejala, catatan nyeri dan perdarahan,
          aktivitas seksual, penggunaan obat, vaksinasi, kunjungan medis, serta
          informasi kesehatan lainnya yang Anda pilih untuk dicatat
        </li>
        <li>
          <strong>[Perawatan Kesuburan]</strong>
          <br />
          Jenis perawatan kesuburan, siklus perawatan, tanggal mulai dan
          berakhirnya perawatan, catatan obat dan suntikan, jadwal perawatan,
          serta rincian perawatan
        </li>
        <li>
          <strong>[Kehamilan]</strong>
          <br />
          Perkiraan tanggal persalinan, usia kehamilan, catatan kunjungan medis,
          vaksinasi, berat badan, gambar USG, pengukuran janin
          (EFW/AC/FL/BPD/HC/CRL), tinggi dan berat badan sebelum hamil, serta
          informasi terkait kehamilan lainnya yang Anda pilih untuk dicatat
        </li>
        <li>
          <strong>[Perawatan Anak]</strong>
          <br />
          Tanggal lahir anak, tinggi, berat badan, dan lingkar kepala saat
          lahir, pengukuran pertumbuhan, catatan dan skor penilaian
          perkembangan, foto terkait perkembangan, informasi kelahiran prematur,
          pemeriksaan kesehatan, vaksinasi, suhu tubuh, penggunaan obat, dan
          catatan penyakit
        </li>
      </PolicyList>

      <PolicySectionTitle>
        3. Periode Penyimpanan dan Penggunaan
      </PolicySectionTitle>
      <PolicyText>
        Saat Anda menghapus catatan yang tersimpan, informasi yang terkait
        dengan catatan tersebut juga akan dihapus. Saat Anda menghapus akun,
        Data Pribadi yang dapat mengidentifikasi Anda akan dihapus. Namun, data
        tertentu yang dihasilkan selama penggunaan Layanan dapat disimpan tanpa
        batas waktu untuk tujuan penelitian, analisis statistik, dan peningkatan
        layanan setelah dianonimkan secara permanen dan tidak dapat dikembalikan
        sehingga Anda tidak dapat diidentifikasi kembali. Data anonim tersebut
        tidak dapat dihubungkan kembali dengan akun atau Data Pribadi Anda.
      </PolicyText>

      <PolicySectionTitle>Hak untuk Menolak Persetujuan</PolicySectionTitle>
      <PolicyText>
        Persetujuan ini bersifat opsional. Anda tetap dapat membuat akun
        pregnancy&baby dan menggunakan fitur yang tidak memerlukan pemrosesan
        informasi kesehatan tanpa memberikan persetujuan ini. Namun, jika Anda
        tidak memberikan persetujuan, Anda mungkin tidak dapat menggunakan fitur
        yang memerlukan pemrosesan informasi kesehatan, termasuk fitur
        pencatatan persiapan kehamilan, perawatan kesuburan, kehamilan, dan
        perawatan anak.
      </PolicyText>
    </PolicyContainer>
  );
};

export default HealthId;
